import { call, put } from '@redux-saga/core/effects';
import { voucherApi, notify, formDataBuilder, apiErrorHandler } from 'services';
import {
  CreateDeliveryVoucherActions as Actions,
  CreateDeliveryVoucherRequestAction as RequestAction,
} from 'store/ducks/deliveryVouchers';

export function* createDeliveryVoucherRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(postData);
    yield call(voucherApi.post, `api/upload-canhoto`, formData);
    onSuccess && onSuccess();
    notify('success', 'Comprovante de entrega enviado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
